import React from 'react';
import { LegalLayout, LegalBlock, InfoGrid } from './LegalLayout';
import { useLanguage } from '../../i18n/LanguageContext';
export function AvisoLegal() {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  return <LegalLayout titleEs="Aviso Legal" titleCa="Avís Legal" subtitleEs="Información legal del sitio web www.georginaconstelaciones.com" subtitleCa="Informació legal del lloc web www.georginaconstelaciones.com" data-id="element-483">
      {/* BLOCK 1 — Identificación */}
      <LegalBlock title={es ? 'Identificación y Titularidad' : 'Identificació i Titularitat'} data-id="element-484">
        <p data-id="element-485">
          {es ? 'En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, el Titular expone sus datos identificativos.' : "En compliment de l'article 10 de la Llei 34/2002, d'11 de juliol, de Serveis de la Societat de la Informació i Comerç Electrònic, el Titular exposa les seves dades identificatives."}
        </p>
        <InfoGrid items={[{
        label: 'Titular',
        value: 'GEORGINA FAHLE RUIZ'
      }, {
        label: 'NIF',
        value: '46996968X'
      }, {
        label: es ? 'Domicilio' : 'Domicili',
        value: 'C/ dels Boters, 4, Vilafranca del Penedès, 08720 Barcelona'
      }, {
        label: es ? 'Email' : 'Correu',
        value: 'georginaconstelaciones@gmail.com'
      }, {
        label: 'Web',
        value: 'www.georginaconstelaciones.com'
      }, {
        label: es ? 'Finalidad' : 'Finalitat',
        value: es ? 'Constelaciones Familiares' : 'Constel·lacions Familiars'
      }]} data-id="element-486" />
      </LegalBlock>

      {/* BLOCK 2 */}
      <LegalBlock title={es ? 'Condiciones de Uso' : "Condicions d'Ús"} data-id="element-487">
        {es ? <>
            <p data-id="element-488">
              La utilización del sitio Web le otorga la condición de Usuario, e
              implica la aceptación completa de todas las cláusulas y
              condiciones de uso incluidas en las páginas: Aviso Legal, Política
              de Privacidad y Política de Cookies.
            </p>
            <p data-id="element-489">
              Si no estuviera conforme con todas y cada una de estas cláusulas
              absténgase de utilizar este sitio Web.
            </p>
            <p data-id="element-490">
              El acceso a este sitio Web no supone, en modo alguno, el inicio de
              una relación comercial con el Titular.
            </p>
            <p data-id="element-491">
              El Usuario está obligado a NO utilizar los contenidos del sitio
              Web con fines ilícitos, lesivos de derechos de terceros, o que
              puedan dañar, inutilizar o deteriorar los sistemas informáticos
              del Titular o de terceros.
            </p>
          </> : <>
            <p data-id="element-492">
              La utilització del lloc web li atorga la condició d'Usuari i
              implica l'acceptació completa de totes les clàusules i condicions
              d'ús incloses a les pàgines: Avís Legal, Política de Privacitat i
              Política de Cookies.
            </p>
            <p data-id="element-493">
              Si no està d'acord amb totes i cadascuna d'aquestes clàusules,
              abstingui's d'utilitzar aquest lloc web.
            </p>
            <p data-id="element-494">
              L'accés a aquest lloc web no suposa, de cap manera, l'inici d'una
              relació comercial amb el Titular.
            </p>
            <p data-id="element-495">
              L'Usuari està obligat a NO utilitzar els continguts del lloc web
              amb finalitats il·lícites, lesives de drets de tercers, o que
              puguin danyar, inutilitzar o deteriorar els sistemes informàtics
              del Titular o de tercers.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 3 */}
      <LegalBlock title={es ? 'Comentarios' : 'Comentaris'} data-id="element-496">
        {es ? <>
            <p data-id="element-497">
              El Titular se reserva el derecho de retirar todos aquellos
              comentarios que vulneren la legislación vigente, lesivos de los
              derechos o intereses de terceros o que no resulten adecuados para
              su publicación.
            </p>
            <p data-id="element-498">
              El Titular no será responsable de las opiniones vertidas por los
              usuarios a través de comentarios, redes sociales u otras
              herramientas de participación.
            </p>
          </> : <>
            <p data-id="element-499">
              El Titular es reserva el dret de retirar tots aquells comentaris
              que vulnerin la legislació vigent, lesionin els drets o interessos
              de tercers o que no resultin adequats per a la seva publicació.
            </p>
            <p data-id="element-500">
              El Titular no serà responsable de les opinions expressades pels
              usuaris a través de comentaris, xarxes socials o altres eines de
              participació.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 4 */}
      <LegalBlock title={es ? 'Mayoría de Edad' : "Majoria d'Edat"} data-id="element-501">
        {es ? <>
            <p data-id="element-502">
              Debe tener al menos 18 años para usar los servicios ofrecidos por
              el Titular, o la mayoría de edad requerida en su país para
              registrarse o utilizarlos.
            </p>
            <p data-id="element-503">
              Si reside fuera de la Región Europea, debe tener al menos 13 años
              para usar el sitio Web.
            </p>
            <p data-id="element-504">
              Si no tiene la edad suficiente para aceptar nuestras condiciones
              en su país, su padre, madre o tutor deben aceptarlas en su nombre.
            </p>
          </> : <>
            <p data-id="element-505">
              Ha de tenir almenys 18 anys per utilitzar els serveis oferts pel
              Titular, o la majoria d'edat requerida al seu país per
              registrar-se o utilitzar-los.
            </p>
            <p data-id="element-506">
              Si resideix fora de la Regió Europea, ha de tenir almenys 13 anys
              per utilitzar el lloc web.
            </p>
            <p data-id="element-507">
              Si no té l'edat suficient per acceptar les nostres condicions al
              seu país, el seu pare, mare o tutor han d'acceptar-les en el seu
              nom.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 5 */}
      <LegalBlock title={es ? 'Medidas de Seguridad' : 'Mesures de Seguretat'} data-id="element-508">
        {es ? <>
            <p data-id="element-509">
              Los datos personales que facilite al Titular pueden ser
              almacenados en bases de datos automatizadas cuya titularidad
              corresponde exclusivamente al Titular, que asume todas las medidas
              técnicas, organizativas y de seguridad que garantizan la
              confidencialidad, integridad y calidad de la información.
            </p>
            <p data-id="element-510">
              El Titular no puede garantizar la inexistencia total de virus u
              otros elementos dañinos en Internet, aunque pone todos los medios
              necesarios para evitar su presencia.
            </p>
          </> : <>
            <p data-id="element-511">
              Les dades personals que faciliti al Titular poden ser
              emmagatzemades en bases de dades automatitzades la titularitat de
              les quals correspon exclusivament al Titular, que assumeix totes
              les mesures tècniques, organitzatives i de seguretat que
              garanteixen la confidencialitat, integritat i qualitat de la
              informació.
            </p>
            <p data-id="element-512">
              El Titular no pot garantir la inexistència total de virus o altres
              elements nocius a Internet, tot i que posa tots els mitjans
              necessaris per evitar-los.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 6 */}
      <LegalBlock title={es ? 'Contenidos' : 'Continguts'} data-id="element-513">
        {es ? <>
            <p data-id="element-514">
              El Titular ha obtenido la información incluida en el sitio Web de
              fuentes que considera fiables, pero no garantiza que sea exacta,
              completa o actualizada. Declina expresamente cualquier
              responsabilidad por error u omisión en la información.
            </p>
            <p data-id="element-515">
              Queda prohibido transmitir contenido ilegal, virus informáticos o
              mensajes que afecten derechos del Titular o de terceros.
            </p>
            <p data-id="element-516">
              El Titular se reserva el derecho a modificar, suspender o cancelar
              el contenido del sitio Web sin necesidad de previo aviso.
            </p>
          </> : <>
            <p data-id="element-517">
              El Titular ha obtingut la informació inclosa al lloc web de fonts
              que considera fiables, però no garanteix que sigui exacta,
              completa o actualitzada. Declina expressament qualsevol
              responsabilitat per error o omissió.
            </p>
            <p data-id="element-518">
              Queda prohibit transmetre contingut il·legal, virus informàtics o
              missatges que afectin drets del Titular o de tercers.
            </p>
            <p data-id="element-519">
              El Titular es reserva el dret de modificar, suspendre o cancel·lar
              el contingut del lloc web sense necessitat de previ avís.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 7 */}
      <LegalBlock title={es ? 'Política de Cookies' : 'Política de Cookies'} data-id="element-520">
        {es ? <>
            <p data-id="element-521">
              El Titular solo obtiene y conserva la siguiente información sobre
              los visitantes:
            </p>
            <ul className="list-none space-y-1.5 pl-1" data-id="element-522">
              <li data-id="element-523">· Nombre de dominio del proveedor y/o dirección IP</li>
              <li data-id="element-524">· Fecha y hora de acceso al sitio Web</li>
              <li data-id="element-525">· Dirección de Internet origen del enlace</li>
              <li data-id="element-526">· Número de visitantes diarios de cada sección</li>
            </ul>
            <p data-id="element-527">
              La información obtenida es totalmente anónima y no puede ser
              asociada a un Usuario concreto.
            </p>
            <p data-id="element-528">
              Para más información consulte nuestra{' '}
              <a href="/politica-cookies" className="text-[#c49a4a] underline hover:text-[#1a3a2a]" data-id="element-529">
                Política de Cookies
              </a>{' '}
              completa.
            </p>
          </> : <>
            <p data-id="element-530">
              El Titular només obté i conserva la informació següent sobre els
              visitants:
            </p>
            <ul className="list-none space-y-1.5 pl-1" data-id="element-531">
              <li data-id="element-532">· Nom de domini del proveïdor i/o adreça IP</li>
              <li data-id="element-533">· Data i hora d'accés al lloc web</li>
              <li data-id="element-534">· Adreça d'Internet d'origen de l'enllaç</li>
              <li data-id="element-535">· Nombre de visitants diaris de cada secció</li>
            </ul>
            <p data-id="element-536">
              La informació obtinguda és totalment anònima i no pot ser
              associada a cap Usuari concret.
            </p>
            <p data-id="element-537">
              Per a més informació, consulteu la nostra{' '}
              <a href="/politica-cookies" className="text-[#c49a4a] underline hover:text-[#1a3a2a]" data-id="element-538">
                Política de Cookies
              </a>{' '}
              completa.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 8 */}
      <LegalBlock title={es ? 'Enlaces a Otros Sitios Web' : 'Enllaços a Altres Llocs Web'} data-id="element-539">
        {es ? <>
            <p data-id="element-540">
              El Titular puede proporcionarle acceso a sitios Web de terceros
              mediante enlaces con la finalidad de informar sobre otras fuentes
              de información.
            </p>
            <p data-id="element-541">
              Estos enlaces no suponen recomendación ni aprobación de dichos
              sitios, que están fuera del control del Titular. El Titular no es
              responsable del contenido de los sitios vinculados.
            </p>
            <p data-id="element-542">
              Si accede a un sitio externo, deberá leer su propia política de
              privacidad.
            </p>
          </> : <>
            <p data-id="element-543">
              El Titular pot proporcionar-li accés a llocs web de tercers
              mitjançant enllaços amb la finalitat d'informar sobre altres fonts
              d'informació.
            </p>
            <p data-id="element-544">
              Aquests enllaços no suposen recomanació ni aprovació d'aquests
              llocs, que estan fora del control del Titular. El Titular no és
              responsable del contingut dels llocs vinculats.
            </p>
            <p data-id="element-545">
              Si accedeix a un lloc extern, haurà de llegir la seva pròpia
              política de privacitat.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 9 */}
      <LegalBlock title={es ? 'Limitación de Responsabilidad' : 'Limitació de Responsabilitat'} data-id="element-546">
        {es ? <>
            <p data-id="element-547">
              El Titular no garantiza que los servicios sean ininterrumpidos o
              estén libres de errores, ni que el servidor esté libre de virus u
              otros componentes nocivos.
            </p>
            <p data-id="element-548">
              El Titular declina cualquier responsabilidad por interrupciones,
              mal funcionamiento, caídas de red, pérdidas de negocio o daños
              indirectos por causas ajenas al Titular.
            </p>
            <p data-id="element-549">
              Se recomienda contrastar la información de este sitio Web con
              otras fuentes antes de tomar decisiones.
            </p>
          </> : <>
            <p data-id="element-550">
              El Titular no garanteix que els serveis siguin ininterromputs o
              estiguin lliures d'errors, ni que el servidor estigui lliure de
              virus o altres components nocius.
            </p>
            <p data-id="element-551">
              El Titular declina qualsevol responsabilitat per interrupcions,
              mal funcionament, caigudes de xarxa, pèrdues de negoci o danys
              indirectes per causes alienes al Titular.
            </p>
            <p data-id="element-552">
              Es recomana contrastar la informació d'aquest lloc web amb altres
              fonts abans de prendre decisions.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 10 */}
      <LegalBlock title={es ? 'Derecho de Exclusión' : "Dret d'Exclusió"} data-id="element-553">
        <p data-id="element-554">
          {es ? 'El Titular se reserva el derecho a denegar o retirar el acceso al sitio Web y los servicios ofrecidos, sin necesidad de preaviso, a aquellos usuarios que incumplan cualquiera de las condiciones de este Aviso Legal.' : "El Titular es reserva el dret a denegar o retirar l'accés al lloc web i als serveis oferts, sense necessitat de preavís, a aquells usuaris que incompleixin qualsevol de les condicions d'aquest Avís Legal."}
        </p>
      </LegalBlock>

      {/* BLOCK 11 */}
      <LegalBlock title={es ? 'Jurisdicción' : 'Jurisdicció'} data-id="element-555">
        {es ? <>
            <p data-id="element-556">
              Este Aviso Legal se rige íntegramente por la legislación española.
            </p>
            <p data-id="element-557">
              Para cuantas cuestiones se susciten sobre la interpretación,
              aplicación y cumplimiento de este Aviso Legal, las partes acuerdan
              someterse a los Jueces y Tribunales de la provincia de Barcelona,
              con renuncia expresa de cualquier otra jurisdicción.
            </p>
          </> : <>
            <p data-id="element-558">
              Aquest Avís Legal es regeix íntegrament per la legislació
              espanyola.
            </p>
            <p data-id="element-559">
              Per a totes les qüestions que se suscitin sobre la interpretació,
              aplicació i compliment d'aquest Avís Legal, les parts acorden
              sotmetre's als Jutges i Tribunals de la província de Barcelona,
              amb renúncia expressa a qualsevol altra jurisdicció.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 12 */}
      <LegalBlock title={es ? 'Contacto' : 'Contacte'} data-id="element-560">
        <p data-id="element-561">
          {es ? 'Si tiene cualquier duda sobre estas condiciones legales o quiere realizar algún comentario, puede escribirnos a:' : "Si té qualsevol dubte sobre aquestes condicions legals o vol fer algun comentari, pot escriure'ns a:"}
        </p>
        <p className="flex items-center gap-2 mt-3" data-id="element-562">
          <span data-id="element-563">📧</span>
          <a href="mailto:georginaconstelaciones@gmail.com" className="text-[#c49a4a] underline hover:text-[#1a3a2a]" data-id="element-564">
            georginaconstelaciones@gmail.com
          </a>
        </p>
      </LegalBlock>
    </LegalLayout>;
}